import { render } from "./Portfolio.vue?vue&type=template&id=0fee1f33&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=0fee1f33&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Alexa\\OneDrive\\Bureau\\infolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fee1f33"]])

export default __exports__